import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProcessClaim, getUpdatedProcess_AC, removeProcessClaim, } from '../store/actions/process';
import { processInstanceSelector } from '../store/selectors/process';
function useProcessInstance(processId, processType) {
    var dispatch = useDispatch();
    var processObject = useSelector(processInstanceSelector(processType, processId));
    useEffect(function () {
        if (processId && processType && processObject) {
            dispatch(addProcessClaim({
                ids: [processId],
                processName: processType,
            }));
        }
        return function () {
            if (processId && processType && processObject) {
                dispatch(removeProcessClaim({
                    ids: [processId],
                    processName: processType,
                }));
            }
        };
    }, [processId, processType, processObject]);
    useEffect(function () {
        if (!processObject && processId) {
            dispatch(getUpdatedProcess_AC(processId));
        }
    }, [processObject, processId]);
    return processObject;
}
export default useProcessInstance;
//# sourceMappingURL=useProcessInstance.js.map